import { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { SiteContext } from "../../contexts/site-context";
const Footer = () => {
  const { siteSettings } = useContext(SiteContext);
  const externalUrl = (url) => {
    if (!url.match(/^[a-zA-Z]+:\/\//)) {
      return (url = "https://" + url);
    }
  };

  return (
    <Fragment>
      {siteSettings ? (
        <section className="footer_one">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3 pr0 pl0">
                <div className="footer_about_widget">
                  <h4>About Site</h4>
                  <p>
                    We`re reimagining how you buy, sell and rent. It`s now
                    easier to get into a place you love. So let`s do this,
                    together.
                  </p>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div className="footer_qlink_widget">
                  <h4>Quick Links</h4>
                  <ul className="list-unstyled">
                    <li>
                      <Link to="#">About Us</Link>
                    </li>
                    <li>
                      <Link to="#">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link to="#">User`s Guide</Link>
                    </li>
                    <li>
                      <Link to="#">Support Center</Link>
                    </li>
                    <li>
                      <Link to="#">Press Info</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div className="footer_contact_widget">
                  <h4>Contact Us</h4>
                  <ul className="list-unstyled">
                    <li
                      className={
                        siteSettings.general_info.email ? `` : `d-none`
                      }
                    >
                      <a href={`mailto:${siteSettings.general_info.email}`}>
                        {siteSettings.general_info.email}
                      </a>
                    </li>
                    <li
                      className={
                        siteSettings.general_info.address ? `` : `d-none`
                      }
                    >
                      <a href="#">{siteSettings.general_info.address}</a>
                    </li>
                    <li
                      className={
                        siteSettings.general_info.phone ? `` : `d-none`
                      }
                    >
                      <a href={`tel:${siteSettings.general_info.phone}`}>
                        {siteSettings.general_info.phone}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {siteSettings && siteSettings.social_media ? (
                <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                  <div className="footer_social_widget">
                    <h4>Follow us</h4>
                    <ul className="mb30">
                      <li
                        className={
                          siteSettings.social_media.facebook
                            ? `list-inline-item`
                            : `list-inline-item d-none`
                        }
                      >
                        <a
                          href={externalUrl(siteSettings.social_media.facebook)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li
                        className={
                          siteSettings.social_media.twitter
                            ? `list-inline-item`
                            : `list-inline-item d-none`
                        }
                      >
                        <a
                          href={externalUrl(siteSettings.social_media.twitter)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li
                        className={
                          siteSettings.social_media.instagram
                            ? `list-inline-item`
                            : `list-inline-item d-none`
                        }
                      >
                        <a
                          href={externalUrl(
                            siteSettings.social_media.instagram
                          )}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li
                        className={
                          siteSettings.social_media.linkedin
                            ? `list-inline-item`
                            : `list-inline-item d-none`
                        }
                      >
                        <a
                          href={externalUrl(siteSettings.social_media.linkedin)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-linkedin"></i>
                        </a>
                      </li>
                      <li
                        className={
                          siteSettings.social_media.skype
                            ? `list-inline-item`
                            : `list-inline-item d-none`
                        }
                      >
                        <a
                          href={externalUrl(siteSettings.social_media.skype)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-skype"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </section>
      ) : null}
      {siteSettings ? (
        <section className="footer_middle_area pt40 pb40">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-xl-6">
                <div className="footer_menu_widget">
                  <ul>
                    <li className="list-inline-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="/about">About</Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="/property">Property</Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="/team">Team</Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 col-xl-6">
                <div className="copyright-widget text-right">
                  <p>© 2022 CentralTX.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : null}
    </Fragment>
  );
};

export default Footer;
